module.exports = __webpack_public_path__ + "1.0/img/title-final-rank.a9883d2a.png";